import React from "react";
import WhyChooseUs from "../components/WhyChooseUS";
import FormPage from "./FormPage";
// import Testimonial from "../components/Testimonial";
import HeroSection from "../components/HeroSection";
import WhoWeAre from "../components/WhoWeAre";
import Comparison from "../components/Difference";

export default function HomePage({ openModal }) {
  // Hero content now a two‑column layout with text+CTA and an embedded video.
  // The slide carousel has been removed per new design requirements.

  return (
    <>
      <HeroSection openModal={openModal} />
      <WhoWeAre />
      <Comparison />
      <WhyChooseUs openModal={openModal} />
      <FormPage />
      {/* <Testimonial /> */}
    </>
  );
}
